module.exports = __webpack_public_path__ + "img/Versorgungsstelle_Verbrauchsgüter.c50494de.svg";